import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * AgencyZoom Update Contact v1 Configuration Validator
 * Validates AgencyZoom contact update configuration
 */
export const Agencyzoom_Update_Contact_1_ConfigValidator = z.object({
    connection: requiredString('AgencyZoom Connection is required'),
    lookupEmail: requiredString('Lookup Email is required'),
    pipelineId: requiredString('Pipeline ID is required'),
    stageId: requiredString('Stage ID is required'),
    leadSourceId: requiredString('Lead Source ID is required'),
    assignedToId: requiredString('Assigned To is required')
});
//# sourceMappingURL=agencyzoom-update-contact-1.js.map